import { observer } from 'mobx-react-lite'
import {
  NoticeBanner,
  NoticeBannerAction,
  NoticeBannerCloseButton,
} from '@/features/shell/notice-banner/NoticeBanner'
import { type Ref, useCallback, useState } from 'react'

interface CallCenterNoticeBannerContainerProps {
  onPress: () => void
  ref?: Ref<HTMLDivElement>
}

export const CallCenterNoticeBannerContainer = observer(
  function CallCenterNoticeBannerContainer({
    onPress,
    ref,
  }: CallCenterNoticeBannerContainerProps) {
    const [isBannerVisible, setIsBannerVisible] = useState(true)
    const closeAnnouncement = useCallback(() => setIsBannerVisible(false), [])

    return isBannerVisible ? (
      <NoticeBanner ref={ref}>
        <NoticeBannerAction onPress={onPress}>
          Call for assistance
        </NoticeBannerAction>

        <NoticeBannerCloseButton onPress={closeAnnouncement} />
      </NoticeBanner>
    ) : null
  },
)
